(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moomenn-live-brands"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-brand-carousel')) {
  customElements.define('mm-brand-carousel', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.mm-brand-viewport');
      this.track = this.querySelector('.mm-brand-track');
      this.group = this.querySelector('.mm-brand-group');
      if (!this.viewport || !this.group) return;
      this.events = new AbortController();
      const on = (el, name, fn, options = {}) => el.addEventListener(name, fn, {...options, signal:this.events.signal});
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.update = () => {
        const width = this.group.getBoundingClientRect().width;
        const view = this.viewport.clientWidth;
        if (!width || !view) return;
        const loop = this.group.children.length > 1 && !this.motion.matches;
        if (width === this.distance && view === this.viewWidth && loop === this.hasAttribute('data-loop')) return;
        const travelled = this.animation && this.distance ? (Number(this.animation.currentTime || 0) * .018) % this.distance : 0;
        this.animation?.cancel();
        this.track.querySelectorAll('[data-brand-clone]').forEach(n => n.remove());
        this.distance = width;
        this.viewWidth = view;
        this.toggleAttribute('data-loop', loop);
        if (!loop) { this.animation = null; this.viewport.scrollLeft = 0; return; }
        const copies = Math.ceil(view / width) + 2;
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.dataset.brandClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach(a => a.tabIndex = -1);
          this.track.appendChild(clone);
        }
        this.animation = this.track.animate([{transform:'translateX(0)'},{transform:`translateX(-${width}px)`}],{duration:width / .018,iterations:Infinity,easing:'linear'});
        this.animation.currentTime = (travelled % width) / .018;
        if (this.userPaused || document.hidden) this.animation.pause();
      };
      this.setPaused = paused => {
        if (paused === this.userPaused) return;
        if (paused) {
          const offset = this.animation ? (Number(this.animation.currentTime || 0) * .018) % this.distance : this.viewport.scrollLeft;
          this.animation?.pause(); this.setAttribute('data-manual',''); this.viewport.scrollLeft = offset;
        } else {
          if (this.animation) this.animation.currentTime = (this.viewport.scrollLeft % this.distance) / .018;
          this.removeAttribute('data-manual'); this.viewport.scrollLeft = 0;
          if (!document.hidden) this.animation?.play();
        }
        this.userPaused = paused; this.toggleAttribute('data-paused', paused);
      };
      on(this.viewport, 'keydown', e => {
        if (e.code === 'Space' && e.target === this.viewport) {
          e.preventDefault(); this.setPaused(!this.userPaused);
        }
        if (e.target === this.viewport && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
          e.preventDefault(); this.setPaused(true);
          this.viewport.scrollBy({left:(e.key === 'ArrowRight' ? 1 : -1) * this.viewport.clientWidth * .75,behavior:this.motion.matches?'auto':'smooth'});
        }
      });
      on(this.viewport,'focusin',e=>{
        const item=e.target.closest('.mm-brand-item');
        if(!item || (!this.userPaused && !this.motion.matches)) return;
        const r=item.getBoundingClientRect(),v=this.viewport.getBoundingClientRect();
        const delta=r.left<v.left ? r.left-v.left : r.right>v.right ? r.right-v.right : 0;
        if(delta) this.viewport.scrollBy({left:delta,behavior:'instant'});
      });
      on(document,'visibilitychange',()=>{if(document.hidden)this.animation?.pause();else if(!this.userPaused)this.animation?.play();});
      on(this.motion,'change',this.update);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.viewport);
      this.observer.observe(this.group);
      this.update();
    }
    disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); this.animation?.cancel(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pcard-color-swatch"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('mm-colour-options')) return;
  let dialog, owner, origin;
  function close() { if (dialog?.open) dialog.close(); }
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'mm-colour-dialog';
    dialog.setAttribute('aria-labelledby', 'MMColourChooserTitle');
    dialog.innerHTML = '<div class="mm-colour-dialog__head"><h2 id="MMColourChooserTitle"></h2><button type="button" class="mm-colour-dialog__close"></button></div><div class="mm-colour-dialog__choices"></div>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', close);
    dialog.addEventListener('click', e => {
      const choice = e.target.closest('[data-mm-choice]');
      if (choice && owner && !choice.hasAttribute('data-sibling') && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && owner.canPreview(choice)) {
        e.preventDefault(); owner.preview(choice); close();
      } else if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); }
    });
    dialog.addEventListener('close', () => { origin?.setAttribute('aria-expanded', 'false'); if (origin?.isConnected) origin.focus(); owner = null; });
    window.addEventListener('pagehide', close);
    window.addEventListener('resize', () => { if (!dialog?.open || !origin) return; const r = origin.getBoundingClientRect(), p = dialog.getBoundingClientRect(); dialog.style.left = Math.max(12, Math.min(r.left, innerWidth - p.width - 12)) + 'px'; dialog.style.top = Math.max(12, Math.min(r.bottom + 8, innerHeight - p.height - 12)) + 'px'; });
    return dialog;
  }
  class MMColourOptions extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.addEventListener('click', e => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        const more = e.target.closest('[data-mm-more]');
        if (more && typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function') {
          e.preventDefault(); const panel = ensureDialog(); if (panel.open) panel.close();
          owner = this; origin = more; more.setAttribute('aria-expanded', 'true');
          panel.querySelector('h2').textContent = this.dataset.label + ' (' + this.dataset.count + ')';
          panel.querySelector('button').textContent = this.dataset.close;
          const list = panel.querySelector('.mm-colour-dialog__choices'); list.replaceChildren(this.querySelector('template').content.cloneNode(true));
          panel.showModal(); const r = more.getBoundingClientRect(); const p = panel.getBoundingClientRect();
          panel.style.left = Math.max(12, Math.min(r.left, innerWidth - p.width - 12)) + 'px';
          panel.style.top = Math.max(12, Math.min(r.bottom + 8, innerHeight - p.height - 12)) + 'px';
          return;
        }
        const choice = e.target.closest('[data-mm-choice]');
        if (choice && !choice.hasAttribute('data-sibling') && this.canPreview(choice)) { e.preventDefault(); this.preview(choice); }
      });
    }
    disconnectedCallback() { if (owner === this) close(); }
    canPreview(choice) {
      const card = this.closest('.product-card, .mm-edit-suggestion-card');
      return !!card && choice.dataset.product === this.dataset.product && !!choice.dataset.variant && !!choice.dataset.image;
    }
    preview(choice) {
      const card = this.closest('.product-card, .mm-edit-suggestion-card'); if (!card) return;
      const image = card.querySelector('.product-card__image--main img, .mm-edit-suggestion__image img');
      if (!image) return;
      image.src = choice.dataset.image; image.srcset = choice.dataset.image + ' 900w';
      image.alt = this.dataset.title + ' — ' + choice.dataset.name;
      const second = card.querySelector('.product-card__image--second'); if (second) second.hidden = true;
      const path = new URL(this.dataset.url, location.href).pathname;
      card.querySelectorAll('a[href]').forEach(link => {
        if (link.closest('mm-colour-options')) return;
        const url = new URL(link.href, location.href); if (url.origin === location.origin && url.pathname === path) link.href = choice.href;
      });
      const price = card.querySelector('.mm-card-price, .mm-edit-suggestion__price');
      if (price) { const span = document.createElement('span'); span.className = 'f-price'; span.textContent = choice.dataset.price; if (choice.dataset.compare) { const was = document.createElement('s'); was.textContent = choice.dataset.compare; span.append(' ', was); } if (choice.hasAttribute('data-sold-out')) { const stock = document.createElement('span'); stock.className = 'mm-choice-stock'; stock.textContent = choice.querySelector('.mm-choice-stock')?.textContent || ''; span.append(' · ', stock); } price.replaceChildren(span); }
      this.querySelectorAll('[data-mm-choice]').forEach(a => { if (a.dataset.name === choice.dataset.name) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      const status = this.querySelector('[data-mm-status]'); status.textContent = choice.getAttribute('aria-label');
      card.dataset.mmPreviewVariant = choice.dataset.variant;
      card.querySelectorAll('[aria-controls]').forEach(control => { const modal = document.getElementById(control.getAttribute('aria-controls')); if (modal?.tagName === 'QUICK-VIEW-MODAL') modal.dataset.productUrl = choice.href; });
    }
  }
  customElements.define('mm-colour-options', MMColourOptions);
})();
  } catch(e) { console.error(e); }
})();

})();
